import { useEffect, useRef, useState } from "react";
import therapyImg from "@/assets/therapy-method.webp";

const TherapyMethodSection = () => {
  const ref = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="therapy-method" ref={ref} className="py-24 bg-secondary">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Text */}
          <div
            className={`min-w-0 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
          >
            <p className="font-sans text-sm uppercase tracking-[0.2em] text-primary mb-2">Unsere Methode</p>
            <h2 className="font-serif text-2xl md:text-4xl font-bold text-foreground mb-2 hyphens-auto" lang="de">
              Biographisch‑systemische Verhaltenstherapie
            </h2>
            <div className="space-y-4 font-sans text-sm text-muted-foreground leading-relaxed mt-6">
              <p>
                Die biographisch‑systemische Verhaltenstherapie verbindet die wissenschaftlich fundierten Methoden der modernen Verhaltenstherapie mit einem erweiterten Blick auf persönliche Lebensgeschichte und zwischenmenschliche Beziehungen.
              </p>
              <p>
                Im Mittelpunkt steht nicht nur das aktuelle Verhalten, sondern auch das Verständnis dafür, wie frühere Erfahrungen, biographische Prägungen und das soziale Umfeld das heutige Denken, Fühlen und Handeln beeinflussen.
              </p>
              <p>
                Durch diese ganzheitliche Perspektive können individuelle Muster besser verstanden und nachhaltige Veränderungen angestoßen werden. Gemeinsam entwickeln wir neue Handlungsmöglichkeiten und stärken vorhandene Ressourcen, damit Sie Herausforderungen im Alltag sicherer bewältigen können.
              </p>
              <p>
                Dabei arbeiten wir lösungsorientiert, transparent und auf Augenhöhe. Ziel ist es, Sie dabei zu unterstützen, mehr Klarheit über sich selbst zu gewinnen und langfristig mehr Stabilität und Selbstwirksamkeit zu erleben.
              </p>
            </div>
          </div>

          {/* Image placeholder */}
          <div
            className={`min-w-0 transition-all duration-700 delay-200 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
          >
            <img src={therapyImg} alt="Christine Sorgenfrey-Schoof – Psychologische Psychotherapeutin" className="rounded-lg object-contain w-3/4 mx-auto" width={600} height={840} loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TherapyMethodSection;
